import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiNoteTextOutline } from "@mdi/js";

// `inline` renders the note on one row (Property Details, Quote); otherwise it
// blocks under a field. Hover reveals the full text in a popover.
const BookingNote = ({ note, inline = false }) =>
  note ? (
    <OverlayTrigger
      placement="bottom"
      trigger={["hover", "focus"]}
      delay={{ show: 100, hide: 200 }}
      overlay={
        <Popover className="jd-note-popover">
          <Popover.Body>
            <Icon
              path={mdiNoteTextOutline}
              size={0.7}
              className="jd-note-popover-icon"
            />
            <span>{note}</span>
          </Popover.Body>
        </Popover>
      }
    >
      <div className={`jd-note${inline ? " jd-note--inline" : ""}`}>
        <Icon path={mdiNoteTextOutline} size={0.7} className="jd-note-icon" />
        <span className="jd-note-text">{note}</span>
      </div>
    </OverlayTrigger>
  ) : null;

export default BookingNote;
